import { useMutation } from '@tanstack/react-query';
import { requestPhoneUpdate, verifyPhoneUpdate } from '../../api/apiOtp';

/**
 * Hook for updating phone number (authenticated users)
 * Two-step process: request OTP → verify OTP
 * @returns {Object} Mutations for both steps
 */
export const usePhoneUpdate = () => {
    // Step 1: Request OTP for new phone
    const requestMutation = useMutation({
        mutationFn: ({ phone }) => {
            return requestPhoneUpdate(phone);
        }
    });

    // Step 2: Verify OTP and update phone
    const verifyMutation = useMutation({
        mutationFn: ({ phone, otp }) => {
            return verifyPhoneUpdate(phone, otp);
        }
    });

    return {
        // Request OTP
        requestUpdate: requestMutation.mutate,
        requestUpdateAsync: requestMutation.mutateAsync,
        isRequesting: requestMutation.isPending,
        requestError: requestMutation.error,
        requestData: requestMutation.data,

        // Verify OTP
        verifyUpdate: verifyMutation.mutate,
        verifyUpdateAsync: verifyMutation.mutateAsync,
        isVerifying: verifyMutation.isPending,
        verifyError: verifyMutation.error,
        verifyData: verifyMutation.data,

        // Combined state
        isPending: requestMutation.isPending || verifyMutation.isPending
    };
};
